"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _messageStyles = _interopRequireDefault(require("./messageStyles"));

var useStyles = (0, _styles.createUseStyles)(_messageStyles.default, 'ToatMessage');

function ToastMessage(_ref) {
  var classesProp = _ref.classes,
      title = _ref.title,
      text = _ref.text,
      type = _ref.type;
  var classes = (0, _overrides.useClasses)(useStyles, classesProp);
  var rootProps = {
    className: classes.root
  };
  var titleProps = {
    className: (0, _classnames2.default)(classes.title, (0, _defineProperty2.default)({}, classes[type], true))
  };
  return /*#__PURE__*/_react.default.createElement("div", rootProps, title && title.length > 0 && /*#__PURE__*/_react.default.createElement("span", titleProps, title), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.message
  }, text));
}

ToastMessage.defaultProps = {
  title: '',
  text: '',
  type: 'info'
};
process.env.NODE_ENV !== "production" ? ToastMessage.propTypes = {
  title: _propTypes.default.string,
  text: _propTypes.default.string,
  type: _propTypes.default.oneOf(['info', 'success', 'error'])
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(ToastMessage);

exports.default = _default;